<template>
  <div class="preview-product" v-if="product">
    <!-- product -->
    <div class="row gx-5 justify-content-center">
      <!-- image area -->
      <div class="col-md-6 col-lg-5 mt-5">
        <div v-if="medias && medias.length" class="product-image">
          <div class="position-relative">
            <div class="owl-carousel" @click="onImageClicked">
              <template v-for="(media, index) in medias">
                <!-- images -->
                <div class="image major" v-if="media.type === 'image'" :key="`media-${index}`" :style="util.getProductDetailImageStyle(media.url)"></div>
                <!-- videos -->
                <div class="video major" v-else-if="media.type === 'video'" :key="`media-${index}`">
                  <iframe :src="media.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </template>
            </div>
            <!--
            <div class="position-absolute btn-gallery-nav left"><button class="btn" @click="onCarouselPrevClicked"><img src="@/assets/img/ic-arrow-left-circle.svg" alt="prev"></button></div>
            <div class="position-absolute btn-gallery-nav right"><button class="btn" @click="onCarouselNextClicked"><img src="@/assets/img/ic-arrow-right-circle.svg" alt="prev"></button></div>
            -->
          </div>
          <div class="row row-cols-6 gx-2">
            <template v-for="(media, index) in medias">
              <!-- images -->
              <div class="col mt-2" v-if="media.type === 'image'" :key="`gallery-${index}`" @click="onGalleryClicked(index)">
                <div class="image gallery border" :class="selectedImg === index ? 'border-loft' : 'border-none'" :style="util.getProductDetailImageStyle(media.thumbnail)"></div>
              </div>
              <!-- videos -->
              <div class="col mt-2" v-else-if="media.type === 'video'" :key="`gallery-${index}`" @click="onGalleryClicked(index)">
                <div class="video gallery border" :class="selectedImg === index ? 'border-loft' : 'border-none'"><i class="bi bi-play-circle"></i></div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- product content -->
      <div class="col-md-6 col-lg-5 mt-5">
        <!-- basic info -->
        <div class="name">{{ product.goodsName }}</div>
        <div class="brand"><router-link :to="`/w/brand/detail/${product.brandId}`" class="text-decoration-none text-dark">{{ brandName }}</router-link></div>
        <!--div class="sn">{{ product.goodsSn }}</div-->
        <!-- desc -->
        <div class="desc mt-4" v-html="product.goodsDesc"></div>
        <!-- options -->
        <div class="option row mt-4" v-if="options && options.length > 0">
          <div class="col-12 mb-3" v-for="(option, indexOpt) in options" :key="`opt-${indexOpt}`">
            <label :for="`opt-${indexOpt}`">{{ option.attrName }}</label>
            <select :id="`opt-${indexOpt}`" class="form-select" v-model="productAttrs[indexOpt].data">
              <option :value="null">請選擇</option>
              <option v-for="(data, indexVal) in option.data" :key="`val-${indexOpt}-${indexVal}`" :value="data">{{ data.attrValue }}</option>
            </select>
          </div>
        </div>
        <!-- price(置於商品描述與規格選項之後，與前台 ProductDetail.vue 保持一致) -->
        <div v-if="util.hasCheaperPrice(product, userRank)" class="mt-4">
          <span class="discount me-2" v-if="util.isPromoteProduct(product) && product.promotePrice">優惠價</span>
          <template v-else-if="shopDiscount">
            <template v-if="userRank && userRank.discount && userRank.discount < 100">
              <template v-if="shopVipDiscount === 1 || (shopVipDiscount === 2 && product.isMemberDiscount)">
                <span class="discount me-2">{{ shopDiscount }}%優惠折扣</span>
                <span class="discount me-2">{{ 100 - userRank.discount }}%會員折扣</span>
              </template>
              <span class="discount me-2" v-else-if="shopDiscount > (100 - userRank.discount)">{{ shopDiscount }}%優惠折扣</span>
              <span class="discount me-2" v-else>{{ 100 - userRank.discount }}%會員折扣</span>
            </template>
            <span class="discount me-2" v-else>{{ shopDiscount }}%優惠折扣</span>
          </template>
          <span class="discount me-2" v-else-if="userRank && userRank.discount && userRank.discount < 100">{{ 100 - userRank.discount }}%會員折扣</span>
          <span class="price text-secondary text-decoration-line-through me-2" v-show="product.shopPrice !== constant.PRODUCT_PRICE_ASK">{{ util.toPriceFormat(product.marketPrice + optionPrice) }}</span>
          <span class="sale-price loft-text-highlight me-2" v-if="product.shopPrice === constant.PRODUCT_PRICE_ASK">價格電洽</span>
          <span class="sale-price loft-text-highlight me-2" v-else>{{ util.toPriceFormat(util.getGoodsPrice(product, userRank, shopVipDiscount, optionPrice)) }}</span>
        </div>
        <div class="price mt-4" v-else>{{ util.toPriceFormat(product.marketPrice + optionPrice) }}</div>
        <!-- operation -->
        <div class="row mt-4">
          <template v-if="product.shopPrice !== constant.PRODUCT_PRICE_ASK">
            <div v-if="isPreorder && preOrderComment" class="offset-4 col-8 pb-2 d-flex align-items-center justify-content-center">
              <span class="pt-1 pb-1 ps-3 pe-3 border border-loft loft-text-highlight"><small>{{ preOrderComment }}</small></span>
            </div>
            <div class="col-4">
              <number-selector v-model="productCount"/>
            </div>
            <div class="col-8">
              <!-- <button v-if="isPreorder" class="btn btn-loft text-white w-100 h-100">商品預購</button> -->
              <button class="btn btn-dark w-100 h-100">加入購物車</button>
            </div>
          </template>
          <div class="offset-4 col-8 d-flex align-items-center justify-content-center">
            <div class="btn-group w-100">
              <button class="btn btn-product-option pt-2 pb-2"><img src="@/assets/img/ic-favorite.svg" alt="add-wishlist"><small class="ms-2">願望清單</small></button>
              <button class="btn btn-product-option pt-2 pb-2" data-bs-toggle="modal" data-bs-target="#consult-modal"><img src="@/assets/img/ic-email.svg" alt="consult"><small class="ms-2">產品諮詢</small></button>
            </div>
          </div>
        </div>
        <!-- <div v-else class="row mt-4">
          <div class="col-12"><div class="border border-loft loft-text-highlight text-center p-2">此商品已下架</div></div>
        </div> -->
        <div class="other-info mt-5">
          <!-- spec -->
          <div class="border-top border-dark">
            <a class="text-decoration-none text-dark" data-bs-toggle="collapse" href="#collapse-spec" role="button" aria-expanded="false" aria-controls="collapse-spec">
              <div class="row pt-2 pb-2">
                <div class="col">商品規格</div>
                <div class="col-auto"><i id="icon-spec" class="bi bi-plus"></i></div>
              </div>
            </a>
            <div id="collapse-spec" class="collapse">
              <div class="pb-2" v-if="specs">
                <div v-for="(spec, index) in specs" :key="`spec-${index}`">{{ spec.name }}：{{ spec.desc }}</div>
              </div>
              <div class="pb-2" v-else>無</div>
            </div>
          </div>
          <!-- brand intro -->
          <div class="border-top border-dark">
            <a class="text-decoration-none text-dark" data-bs-toggle="collapse" href="#collapse-brand-intro" role="button" aria-expanded="false" aria-controls="collapse-brand-intro">
              <div class="row pt-2 pb-2">
                <div class="col">品牌介紹</div>
                <div class="col-auto"><i id="icon-brand-intro" class="bi bi-plus"></i></div>
              </div>
            </a>
            <div id="collapse-brand-intro" class="collapse"><div class="pb-2" v-html="util.getHtml(brandDesc)"></div></div>
          </div>
          <!-- note -->
          <div class="border-top border-bottom border-dark">
            <a class="text-decoration-none text-dark" data-bs-toggle="collapse" href="#collapse-note" role="button" aria-expanded="false" aria-controls="collapse-note">
              <div class="row pt-2 pb-2">
                <div class="col">注意事項</div>
                <div class="col-auto"><i id="icon-note" class="bi bi-plus"></i></div>
              </div>
            </a>
            <div id="collapse-note" class="collapse"><div class="pb-2" v-html="util.getHtml(product.goodsBrief)"></div></div>
          </div>
        </div>
      </div>
    </div>
    <!-- suggestion -->
    <div class="mt-3">
      <horizontal-product-list id="suggestion" title="你可能也會喜歡" :product-ids="suggestedProducts" subtitle="You May Also Like"/>
    </div>
    <!-- consultion modal -->
    <consultion-modal :product="product"/>
    <!-- image modal -->
    <div id="image-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body position-relative" v-if="medias && medias.length > selectedImg">
            <img :src="util.getImageUrl(medias[selectedImg].url)" alt="orig-image">
            <button type="button" class="btn p-3 btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import previewApi from '@/api/preview.js'
import HorizontalProductList from '@/components/Product/HorizontalProductList.vue'
import NumberSelector from '@/components/NumberSelector.vue'
import ConsultionModal from '@/components/ConsultionModal.vue'
import 'owl.carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'

export default {
  name: 'ProductDetail',
  components: {
    HorizontalProductList,
    NumberSelector,
    ConsultionModal
  },
  data: function () {
    return {
      product: null,
      gallery: null,
      attrs: null,
      attrGallery: null,
      productAttrs: [],
      brand: null,
      productCount: 1,
      selectedImg: 0,
      owlCarousel: null,
      suggestedProducts: [],
      userRank: null,
      shopVipDiscount: false
    }
  },
  computed: {
    constant: function () {
      return constant
    },
    util: function () {
      return util
    },
    productId: function () {
      return Number(this.$route.params.id)
    },
    brandName: function () {
      return this.brand ? this.brand.brandName : null
    },
    brandDesc: function () {
      return this.brand ? this.brand.brandDesc : null
    },
    shopDiscount: function () {
      return util.getProductDiscount(this.product)
    },
    medias: function () {
      var ret = []
      if (this.product) {
        // product images
        ret.push({ type: 'image', url: this.product.originalImg, thumbnail: this.product.goodsImg })
        // gallery images
        if (this.gallery) {
          this.gallery.forEach(e => {
            ret.push({ type: 'image', url: e.imgOriginal, thumbnail: e.imgUrl })
          })
        }
        // videos
        if (this.product.videoUrl && this.getYtKey(this.product.videoUrl)) {
          ret.push({ type: 'video', url: `https://www.youtube.com/embed/${this.getYtKey(this.product.videoUrl)}`, thumbnail: null })
        }
        if (this.product.videoUrl2 && this.getYtKey(this.product.videoUrl2)) {
          ret.push({ type: 'video', url: `https://www.youtube.com/embed/${this.getYtKey(this.product.videoUrl2)}`, thumbnail: null })
        }
        if (this.product.videoUrl3 && this.getYtKey(this.product.videoUrl3)) {
          ret.push({ type: 'video', url: `https://www.youtube.com/embed/${this.getYtKey(this.product.videoUrl3)}`, thumbnail: null })
        }
        // attribute images
        if (this.attrGallery) {
          this.attrGallery.forEach(e => {
            ret.push({ type: 'image', url: e.imgOriginal, thumbnail: e.imgUrl })
          })
        }
      }
      return ret
    },
    options: function () {
      var ret = []
      if (this.attrs) {
        this.attrs.forEach(e => {
          if (e.attrType) {
            var attr = ret.find(r => (r.attrName === e.attrName))
            if (attr) {
              attr.data.push(e)
            } else {
              ret.push({ attrId: e.attrId, attrName: e.attrName, data: [e] })
            }
          }
        })
      }
      return ret
    },
    specs: function () {
      var ret = null
      if (this.attrs) {
        var filteredData = this.attrs.filter(e => (!e.attrType))
        if (filteredData && filteredData.length) {
          ret = this.attrs.filter(e => (!e.attrType)).map(e => ({ name: e.attrName, desc: e.attrValue }))
        }
      }
      return ret
    },
    isPreorder: function () {
      return this.productAttrs && this.productAttrs.some(e => (e.data && e.data.isPreOrder))
    },
    preOrderComment: function () {
      var ret = null
      if (this.productAttrs) {
        var option = this.productAttrs.find(e => (e.data && e.data.isPreOrder && e.data.preOrderComment))
        if (option && option.data.preOrderComment) {
          var comment = JSON.parse(option.data.preOrderComment)
          var unit = null
          switch (comment.type) {
            case constant.PRE_ORDER_COMMENT_TYPE.MONTH:
              unit = '個月'
              break
            case constant.PRE_ORDER_COMMENT_TYPE.WEEK:
              unit = '週'
              break
            case constant.PRE_ORDER_COMMENT_TYPE.DAY:
              unit = '個工作天'
              break
            default:
              break
          }
          if (comment && unit) {
            ret = `訂購後約 ${comment.min} - ${comment.max} ${unit}到貨`
          }
        }
      }
      return ret
    },
    optionPrice: function () {
      var ret = 0
      if (this.productAttrs) {
        this.productAttrs.forEach(e => {
          if (e.data) {
            ret += Number(e.data.attrPrice)
          }
        })
      }
      return ret
    }
  },
  watch: {
    productId: function (value) {
      this.product = null
      this.$router.go()
    },
    options: function (value) {
      if (value) {
        this.productAttrs = value.map(e => ({ attrId: e.attrId, attrName: e.attrName, data: null }))
      }
    }
  },
  mounted: function () {
    this.apiGetProduct()
  },
  methods: {
    apiGetProduct: function () {
      if (!this.productId) {
        return
      }
      var self = this
      previewApi.getProduct(this.productId, function (err, rspData) {
        if (err) {
          alert(`${err}: ${rspData}`)
          return
        }
        self.product = rspData
        self.apiGetSuggestedProducts()
        self.apiGetGallery()
        self.apiGetAttrs()
        self.apiGetBrand()
      })
    },
    apiGetSuggestedProducts: function () {
      if (!this.product || !this.product.brandId) {
        return
      }
      var self = this
      previewApi.getBrandProducts(this.product.brandId, { page: 1, limit: 9 }, function (err, rspData) {
        if (err) {
          return
        }
        self.suggestedProducts = rspData
          .filter(p => p.goodsId !== self.productId)
          .slice(0, 8)
          .map(p => p.goodsId)
      })
    },
    apiGetGallery: function () {
      if (!this.productId) {
        return
      }
      var self = this
      previewApi.getGallery(this.productId, function (err, rspData) {
        if (err) {
          alert(`${err}: ${rspData}`)
          return
        }
        self.gallery = rspData
        if (self.product && self.product.galleryIds) {
          self.apiGetAttrGallery()
        } else {
          self.updateCarousel()
        }
      })
    },
    apiGetAttrs: function () {
      if (!this.productId) {
        return
      }
      var self = this
      previewApi.getAttrs(this.productId, function (err, rspData) {
        if (err) {
          alert(`${err}: ${rspData}`)
          return
        }
        self.attrs = rspData
        self.handleCollapseEvents()
      })
    },
    apiGetAttrGallery: function () {
      if (!this.product || !this.product.galleryIds) {
        return
      }
      var self = this
      previewApi.getAttrGallery(this.product.galleryIds, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.attrGallery = rspData
        self.updateCarousel()
      })
    },
    apiGetBrand: function () {
      if (!this.product) {
        return
      }
      var self = this
      previewApi.getBrand(this.product.brandId, function (err, rspData) {
        if (err) {
          alert(`${err}: ${rspData}`)
          return
        }
        self.brand = rspData
      })
    },
    getYtKey: function (url) {
      var ret = null
      if (url) {
        if (url.indexOf('https://youtu.be/') === 0) {
          ret = url.replace('https://youtu.be/', '')
        } else if (url.indexOf('https://www.youtube.com/watch?v=') === 0) {
          ret = url.replace('https://www.youtube.com/watch?v=', '')
        }
      }
      return ret
    },
    updateCarousel: function () {
      // enable owl carousel
      var self = this
      this.$nextTick().then(() => {
        self.owlCarousel = $('.owl-carousel').owlCarousel({
          items: 1,
          dots: false,
          onChanged: function (event) {
            self.selectedImg = event.item.index
          }
        })
      })
    },
    handleCollapseEvents: function () {
      // collapse event handler
      const collSpec = document.getElementById('collapse-spec')
      collSpec.addEventListener('show.bs.collapse', () => {
        $('#icon-spec').toggleClass('bi-plus bi-dash')
      })
      collSpec.addEventListener('hide.bs.collapse', () => {
        $('#icon-spec').toggleClass('bi-plus bi-dash')
      })
      const collBrand = document.getElementById('collapse-brand-intro')
      collBrand.addEventListener('show.bs.collapse', () => {
        $('#icon-brand-intro').toggleClass('bi-plus bi-dash')
      })
      collBrand.addEventListener('hide.bs.collapse', () => {
        $('#icon-brand-intro').toggleClass('bi-plus bi-dash')
      })
      const collNote = document.getElementById('collapse-note')
      collNote.addEventListener('show.bs.collapse', () => {
        $('#icon-note').toggleClass('bi-plus bi-dash')
      })
      collNote.addEventListener('hide.bs.collapse', () => {
        $('#icon-note').toggleClass('bi-plus bi-dash')
      })
    },
    onImageClicked: function () {
      new bootstrap.Modal(document.getElementById('image-modal')).show()
    },
    onGalleryClicked: function (index) {
      if (!this.owlCarousel) {
        return
      }
      this.owlCarousel.trigger('to.owl.carousel', [index])
    }
  }
}
</script>

<style scoped>
.product-image .image {
  width: 100%;
  padding-bottom: 100%;
}
.product-image .video.major {
  width: 100%;
  padding-top: 100%;
  position: relative;
}
.product-image .video.major iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.product-image .owl-carousel, .product-image .image.gallery {
  cursor: pointer;
}
.product-image .video.gallery {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.product-image .video.gallery i {
  font-size: 2rem;
  color: var(--bs-secondary);
  text-align: center;
}
/*
.product-image .btn-gallery-nav {
  top: calc(50% - 14px);
  display: flex;
  z-index: 1;
  opacity: 0;
  transition: opacity .2s ease;
}
.product-image:hover .btn-gallery-nav {
  opacity: 1;
}
.product-image .btn-gallery-nav.left {
  left: 0;
}
.product-image .btn-gallery-nav.right {
  right: 0;
}
*/
#image-modal.show {
  display: flex !important;
}
#image-modal .modal-dialog {
  max-width: unset;
}
#image-modal .modal-dialog img {
  max-width: 90vw;
  max-height: 90vh;
}
.brand {
  font-size: 20px;
  font-family: 'Noto Serif TC', serif;
  line-height: 0.8;
}
.name {
  font-size: 28px;
  font-weight: 500;
  padding-bottom: 5px;
}
.sn {
  font-size: 1rem;
  font-weight: 700;
}
.desc, .option, .other-info {
  font-size: 1rem;
  font-weight: 400rem;
  letter-spacing: 0.05rem;
}
.option select {
  background-color: #cccccc;
}
.price {
  font-size: 1.5rem;
}
.sale-price {
  font-size: 1.5rem;
}
.discount {
  padding: 2px 8px;
  background-color: var(--loft-color);
  color: white;
  font-size: 0.9rem;
}
.border-loft {
  border-color: var(--loft-color) !important;
}
.btn-loft {
  background-color: var(--loft-color);
}
.btn-product-option {
  font-size: 0.6rem;
  border-radius: 0;
  background-color: var(--bg-color);
  border-color: lightgray;
  width: 100%;
}
.btn-product-option:hover {
  border-color: var(--bs-dark);
}
.btn-close {
  top: 0;
  right: 0;
  z-index: 1;
}
@media screen and (max-width: 767px) {
  .brand {
    font-size: 2rem;
    line-height: 1.4;
  }
}
</style>
